let Annotation =[
  {
    "Year": "Tutorial",
    "annotation1EN": "Africa",
    "annotation2EN": "Asia",
    "annotation3EN": "Asia Pacific",
    "annotation4EN": "Europe",
    "annotation5EN": "Latin America",
    "annotation6EN": "Middle East",
    "annotation7EN": "US and Canada",
    "annotation1AR": "أفريقيا",
    "annotation2AR": "آسيا",
    "annotation3AR": "آسيا والمحيط الهادئ",
    "annotation4AR": "أوروبا",
    "annotation5AR": "أميركا اللاتينية",
    "annotation6AR": "الشرق الأوسط",
    "annotation7AR": "الولايات المتحدة وكندا"
  },
  {
    "Year": "Overall",
    "annotation1EN": "The US has voted \"no\" the most number of times, followed by Israel and the UK.",
    "annotation2EN": "Mexico has voted \"yes\" the most number of times, followed by the Philippines and Venezuela.",
    "annotation3EN": "France has voted to \"abstain\" the most number of times, followed by the UK and Belgium.",
    "annotation4EN": "African and Latin American countries are much more likely to vote \"yes\" across resolutions.",
    "annotation5EN": "European states, along with the US, Canada and Israel, tend to vote \"no\" or \"abstain\" on more resolutions.",
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "الولايات المتحدة كانت أكثر الدول التي صوتت بـ\"لا\" تلتها إسرائيل وبريطانيا.",
    "annotation2AR": "كانت المكسيك الأكثر تصويتا بالرفض، تلتها الفلبين وفنزويلا.",
    "annotation3AR": "كانت فرنسا أكثر دولة تمتنع عن التصويت تلتها المملكة المتحدة فبلجيكا.",
    "annotation4AR": "كانت دول أفريقيا وأميركا اللاتينية الأكثر تصويتا بنعم على القرارات.",
    "annotation5AR": "صوتت الدول الأوروبية وكذلك الولايات المتحدة وإسرائيل بـ\"لا\" أو امتنعت عن التصويت في معظم القرارات.",
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1940,
    "annotation1EN": "Colonialism was the most debated topic during the 1940s.",
    "annotation2EN": "The Israeli-Palestinian conflict was the second most debated topic of the 1940s.",
    "annotation3EN": "Eastern European countries voted \"yes\" on more resolutions discussing nuclear weapons and disarmament.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "تناولت معظم قرارات الجمعية مسألة الاستعمار.",
    "annotation2AR": "كان الصراع العربي الإسرائيلي ثاني أكثر المواضيع  نقاشا في فترة الأربعينيات.",
    "annotation3AR": "صوتت دول الكتلة الشرقية بنعم على معظم القرارات التي ناقشت الأسلحة  النووية ونزع السلاح.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1950,
    "annotation1EN": "Colonialism remained the most debated topic during the 1950s.",
    "annotation2EN": "Western states, led by the UK and Belgium, were more likely to vote \"no\" on resolutions pertaining to decolonisation.",
    "annotation3EN": "Europe had the highest number of countries join the UN in the decade",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "ظل موضوع الاستعمار أكثر المواضيع إثارة للنقاش في حقبة الخمسينيات.",
    "annotation2AR": "الدول الغربية بقيادة بريطانيا فضلت  التصويت بـ \"لا\" على القرارات الهادفة للتخلص من الاستعمار.",
    "annotation3AR": null,
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1960,
    "annotation1EN": "Colonialism, once again, was the most debated topic during the 1960s.",
    "annotation2EN": "Portugal voted \"no\" more than any other country on resolutions about decolonisation.",
    "annotation3EN": "France prominently voted to abstain on issues related to disarmament and nuclear weapons.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "خلال الستينيات استمر موضوع الاستعمار  الأكثر إثارة للجدل.",
    "annotation2AR": "كانت البرتغال أكثر الدول تصويتا ضد القرارات المتعلقة بالتحرر من الاستعمار.",
    "annotation3AR": "في معظم الحالات امتنعت فرنسا عن التصويت على القرارات المتعلقة بنزع السلاح والتسلح النووي.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1970,
    "annotation1EN": "Economic Development was the most debated topic during the 1970s.",
    "annotation2EN": "African states continued to vote \"yes\" on nearly every resolution. ",
    "annotation3EN": "Apartheid South Africa was expelled from the UN in 1974.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "في عقد السبعينيات كان موضوع التنمية الاقتصادية الأكثر نقاشا ومتابعة في الجمعية العامة.",
    "annotation2AR": "واصلت الدول الأفريقية التصويت بـ\"نعم\" لصالح معظم القرارات.",
    "annotation3AR": "تم إقصاء نظام الفصل العنصري في جنوب أفريقيا عام 1974.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1980,
    "annotation1EN": "The Israeli-Palestinian conflict was the most debated topic during the 1980s.",
    "annotation2EN": "Arms control was the second most debated topic of the 1980s.",
    "annotation3EN": "Guatemala was the only country to vote against the admission of Belize in the UN.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "في الثمانينيات كان موضوع الصراع الفلسطيني الإسرائيلي الأكثر نقاشا.\n",
    "annotation2AR": "مراقبة التسلح كان الموضوع الأكثر نقاشا في الثمانينيات.",
    "annotation3AR": "كانت غواتيمالا هي الدولة الوحيدة التي صوتت بـ\"لا\" على انضام دولة بليز إلى الأمم المتحدة.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 1990,
    "annotation1EN": "The Israeli-Palestinian conflict was the most debated topic during the 1990s.",
    "annotation2EN": "Israel and the US voted \"no\" more than any other countries on resolutions about the Israeli-Palestinian conflict.",
    "annotation3EN": "Fourteen former Soviet Republics, mostly from Europe, became members of the UN.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "بقي موضوع الصراع الفلسطيني الإسرائيلي الأكثر نقاشا في فترة التسعينيات.",
    "annotation2AR": "كانت البرتغال أكثر الدول تصويتا ضد القرارات المتعلقة بالتحرر من الاستعمار.",
    "annotation3AR": "انضمت 14 دولة من جمهوريات الاتحاد السوفياتي -معظمها من أوروبا- إلى عضوية الأمم المتحدة.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 2000,
    "annotation1EN": "Human rights was the most debated topic during the 2000s.",
    "annotation2EN": "Oceanic islands, including the Marshall Islands, Micronesia and Palau, voted along similar lines with the US and Israel on the Israeli-Palestinian conflict.",
    "annotation3EN": "African and Latin American countries continued to vote \"yes\" the most, European countries the least.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "أكثر من 1.5 زيادة في قرارات حقوق الإنسان في الألفية الجديدة.",
    "annotation2AR": "صوتت دول جزر المحيط الهادئ وجزر مارشال وميكرونيزيا وبالاو إلى جانب الولايات المتحدة وإسرائي، في موضوع الصراع الفلسطيني الإسرائيلي.",
    "annotation3AR": "واصلت الدول الأفريقية ودول أميركا اللاتينية تصدر التصويت بنعم، بينما كانت الدول الأوروبية الأقل.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  },
  {
    "Year": 2010,
    "annotation1EN": "Arms control, followed closely by human rights, was the most discussed topic of the 2010s.",
    "annotation2EN": "South Sudan gained independence after a decade-long civil war and became the newest member of the UN.",
    "annotation3EN": "For the first time since the 1970s, Canada voted \"no\" three times more than \"yes\" on Israeli-Palestinian conflict resolutions.",
    "annotation4EN": null,
    "annotation5EN": null,
    "annotation6EN": null,
    "annotation7EN": null,
    "annotation1AR": "إضافة إلى موضوع مراقبة التسلح كانت حقوق الإنسان من المواضيع الأكثر نقاشا خلال العقد الأول من الألفية الجديدة.",
    "annotation2AR": "أصبحت دولة جنوب السودان الأحدث في الانضام إلى الأمم المتحدة بعد انفصالها عن السودان.",
    "annotation3AR": " كندا صوتت بـ\"لا\" أكثر بثلاث مرات من تصويتها بـ\"نعم\" على القرارات المتعلقة بالصراع الفسطيني الإسرائيلي لأول مرة منذ السبعينيات.",
    "annotation4AR": null,
    "annotation5AR": null,
    "annotation6AR": null,
    "annotation7AR": null
  }
]
export default Annotation